import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/utils/services/http.service';
import { ErrorService } from 'src/app/utils/services/error.service';
import { SharedService } from 'src/app/utils/services/shared.service';
import { throwError, BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LeadsService {
  private btnStatus = new BehaviorSubject<any>({});
  public preservePageData = new PreservePageData();
  private searchStatus = new BehaviorSubject<any>({});
  private resetSearch = new BehaviorSubject<any>({});
  private statusCount = new BehaviorSubject<any>({});
  private uploadStatus = new ReplaySubject<any>();
  private DashboardId=new ReplaySubject<any>();
  constructor(
    private httpService: HttpService,
    private errService: ErrorService,
    private sharedService: SharedService) { }

  createLead(url: any, data: any): Observable<any> {
    return this.httpService.post(url, data, 'ihsUrl')
      .pipe(
        map((res: Response) => {
           return (res.hasOwnProperty('body') ? res.body : res);
        }),
        catchError(error => {
          this.errorHandler(error);
          return throwError(error.hasOwnProperty('error') ? error.error : error);
        })
      );
  }

  getLeads(query): Observable<any> {
    return this.httpService.get(query, 'ihsUrl').pipe(
      map((res: Response) => {
        return (res.hasOwnProperty('body') ? res.body : res);
      }),
      catchError(error => {
        // this.sharedService.display(false);
        this.errorHandler(error);
        return throwError(error.hasOwnProperty('error') ? error.error : error);
      })
    );
  }

  assignLeads(query, data) {
    return this.httpService.put(query, data, 'ihsUrl').pipe(
      map((res: Response) => {
        this.sharedService.display(false);
        return (res.hasOwnProperty('body') ? res.body : res);
      }),
      catchError(error => {
        this.sharedService.display(false);
        this.errorHandler(error);
        return throwError(error.hasOwnProperty('error') ? error.error : error);
      })
    );
  }
  updateLead(query, data) {
    return this.httpService.put(query, data, 'ihsUrl').pipe(
      map((res: Response) => {
        this.sharedService.display(false);
        return (res.hasOwnProperty('body') ? res.body : res);
      }),
      catchError(error => {
        this.sharedService.display(false);
        this.errorHandler(error);
        return throwError(error.hasOwnProperty('error') ? error.error : error);
      })
    );
  }

  deleteLead(query): Observable<any> {
    return this.httpService.delete(query, 'ihsUrl').pipe(
      map((res: Response) => {
        this.sharedService.display(false);
        return (res.hasOwnProperty('body') ? res.body : res);
      }),
      catchError(error => {
        this.sharedService.display(false);
        this.errorHandler(error);
        return throwError(error.hasOwnProperty('error') ? error.error : error);
      })
    );
  }

  downloadData(query): Observable<any> {
    return this.httpService.get(query).pipe(
      map((res: Response) => {
       return (res.hasOwnProperty('body') ? res.body : res);
      }),
      catchError(error => {
        this.errorHandler(error);
        return throwError(error.hasOwnProperty('error') ? error.error : error);
      })
    );
  }
  downloadWithData(query, data): Observable<any> {
    return this.httpService.filePostDownload(query, data, 'ihsUrl')
      .pipe(
        map((res: Response) => {
          return res;
        }),
        catchError(error => {
          this.errorHandler(error);
          return throwError(error.json());
        })
      );
  }
  uploadCsvData(query, data) {
    return this.httpService.post(query, data, 'ihsUrl')
      .pipe(
        map((res: Response) => {
          return res;
        }),
        catchError(error => {
          this.errorHandler(error);
          return throwError(error.json());
        })
      );
  }
  upload(url: any, data: any): Observable<any> {
    return this.httpService.postApi(url, data, 'ihsUrl')
      .pipe(
        map((res: Response) => {
          return (res.hasOwnProperty('body') ? res.body : res);
        }),
        catchError(error => {
          this.errorHandler(error);
          return throwError(error.hasOwnProperty('error') ? error.error : error);
        })
      );
  }
  getDropdownsData(query, data: any): Observable<any> {
    return this.httpService.post(query, data, 'ihsUrl')
      .pipe(
      map((res: Response) => {
        return (res.hasOwnProperty('body') ? res.body : res);
      }),
      catchError(error => {
        // this.sharedService.display(false);
        this.errorHandler(error);
        return throwError(error.hasOwnProperty('error') ? error.error : error);
      })
    );
  }

  get(query): Observable<any> {
    return this.httpService.get(query).pipe(
      map((res: Response) => {
        return (res.hasOwnProperty('body') ? res.body : res);
      }),
      catchError(error => {
        // this.sharedService.display(false);
        this.errorHandler(error);
        return throwError(error.hasOwnProperty('error') ? error.error : error);
      })
    );
  }

  post(url: any, data: any): Observable<any> {
    return this.httpService.post(url, data, 'ihsUrl')
      .pipe(
        map((res: Response) => {
          return (res.hasOwnProperty('body') ? res.body : res);
        }),
        catchError(error => {
          this.errorHandler(error);
          return throwError(error.hasOwnProperty('error') ? error.error : error);
        })
      );
  }
  downloadReport(url: any, data: any): Observable<any> {
    return this.httpService.post(url, data, 'ihsUrl')
      .pipe(
        map((res: Response) => {
          return res;
        }),
        catchError(error => {
          this.errorHandler(error);
          return throwError(error);
        })
      );
  }
  dashboard(url: any, data: any): Observable<any> {
    return this.httpService.post(url, data,'ihsUrl')
      .pipe(
        map((res: Response) => {
          return (res.hasOwnProperty('body') ? res.body : res);
        }),
        catchError(error => {
          this.errorHandler(error);
          return throwError(error.hasOwnProperty('error') ? error.error : error);
        })
      );

  }


  errorHandler(error: any) {
    this.errService.handleError(error)
  }

  // to set the subscription data
  setSubscription(subsName, data) {
    switch (subsName) {
      case 'btn-status':
        this.btnStatus.next(data);
        break;
      case 'search':
        this.searchStatus.next(data);
        break;
      case 'resetSearch':
        this.resetSearch.next(data)
        break;
    }
  }
  setStatusCount(data) {
    this.statusCount.next(data);
  }
  setDashBoardId(data) {
    this.DashboardId.next(data);
  }
  getDaashBoardId() {
    let subscription: any;
    subscription = this.DashboardId.asObservable();
    return subscription;  }
  getStatusCount() {
    let subscription: any;
    subscription = this.statusCount.asObservable();
    return subscription;
  }
  setUploadStatus(data) {
    this.uploadStatus.next(data);
  }
  getUploadStatus() {
    let subscription: any;
    subscription = this.uploadStatus.asObservable();
    return subscription;
  }
 
  // to fetch the subscription data
  getSubscription(subsName) {
    let subscription: any;
    switch (subsName) {
      case 'btn-status':
        subscription = this.btnStatus.asObservable();
        break;
      case 'search':
        subscription = this.searchStatus.asObservable();
        break;
      case 'resetSearch':
        subscription = this.resetSearch.asObservable()
        break;
    }
    return subscription;
  }
}
export class PreservePageData {
  public pageNumber: number;
  public searchText: string;
  public pageSize: number;

  constructor(d: any = {}) {
    this.pageNumber = d.pageNumber || 0;
    this.searchText = d.searchText || '';
    this.pageSize = d.hasOwnProperty('pageSize') ? d.pageSize : 10;
  }
}
